import { createContext, useContext, useReducer } from 'react';

const SendBackContext = createContext(null);

export const useSendBackContext = () => {
  const ctx = useContext(SendBackContext);
  if (!ctx) throw new Error('useSendBackContext doit être utilisé dans <SendBackProvider>');
  return ctx;
};

const initialState = {
  fetchAlert: false,
  alertMessage: '',
};

function reducer(state, action) {
  switch (action.type) {
    case 'PAGE_SENDBACK_STATES_UPDATE':
      return { ...state, ...action.payload };
    default:
      return state;
  }
}

export function SendBackProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const value = { ...state, dispatch };
  return <SendBackContext.Provider value={value}>{children}</SendBackContext.Provider>;
}
